module.exports = __webpack_public_path__ + "static/media/send_message_icon.7084e973.png";